import { Component, OnInit, signal } from '@angular/core';
import { MatSidenav, MatSidenavContainer, MatSidenavContent } from '@angular/material/sidenav';
import { OrgLeftSidebarComponent } from '../org-left-sidebar/org-left-sidebar.component';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-org-base',
  imports: [MatSidenavContainer, MatSidenavContent, MatSidenav, OrgLeftSidebarComponent, RouterOutlet],
  templateUrl: './org-base.component.html',
  styleUrl: './org-base.component.scss'
})
/**
 * Begründung: Allgemeine Base/Einstiegskomponente für den Orgadmin
 */
export class OrgBaseComponent implements OnInit {
  isSidebarHidden = signal<boolean>(localStorage.getItem('sidenavState') !== 'opened');

  get sidenavState(): string {
    return this.isSidebarHidden() ? 'closed' : 'opened';
  }

  onSidebarToggle(isOpen: boolean): void {
    this.isSidebarHidden.set(isOpen);
  }

  ngOnInit(): void {
    localStorage.setItem('sidenavState', 'opened');
  }
}
